import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { UsersContent } from "@/features/dashboard/usuarios/components/UsersContent";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";

export const Route = createFileRoute("/_private/dashboard/_base/usuarios/editar/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Editar Usuário</DashboardComponents.Title>

      <UsersContent />
    </Stack>
  );
}
